import * as React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import styled from 'styled-components';

interface ICenterModalProps {
  className?: string;
  children?: React.ReactNode;
  title: string;
  show: boolean;
  onHide(): any;
  backdrop?: boolean;
}

const StyledModal = styled(BootstrapModal)`
  .modal-dialog .modal-content {
    background-color: ${({ theme }) => theme.colors.modal};
  }
`;

const Modal: React.FC<ICenterModalProps> = (props: ICenterModalProps) => {
  const { show, title, children, onHide, className, backdrop = true } = props;
  return (
    <StyledModal
      className={`modal ${className ?? ''}`}
      show={show}
      onHide={() => onHide()}
      backdrop={backdrop}
      dialogClassName="modal-sm modal-dialog-centered"
      data-testid="modal-component"
    >
      {title && (
        <BootstrapModal.Header closeButton data-testid="modal-header">
          <BootstrapModal.Title id="center-modal" data-testid="modal-title">
            <b>{title}</b>
          </BootstrapModal.Title>
        </BootstrapModal.Header>
      )}
      <BootstrapModal.Body data-testid="modal-body">
        {children}
      </BootstrapModal.Body>
    </StyledModal>
  );
};

export default Modal;
